import { supabase } from '../lib/supabase';

export const storageService = {
  // Upload hero image for a post
  async uploadHeroImage(postId, file) {
    console.log('[Storage] Starting hero image upload:', { postId, fileName: file?.name, fileSize: file?.size });
    
    const fileExt = file?.name?.split('.')?.pop();
    const fileName = `${Date.now()}-${Math.random()?.toString(36)?.substring(7)}.${fileExt}`;
    const filePath = `posts/${postId}/hero/${fileName}`;

    console.log('[Storage] Upload path:', filePath);

    const { data, error } = await supabase?.storage?.from('blog')?.upload(filePath, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (error) {
      console.error('[Storage] Upload error:', error);
      throw error;
    }

    console.log('[Storage] Upload successful:', data);

    // Get public URL
    const { data: urlData } = supabase?.storage?.from('blog')?.getPublicUrl(filePath);
    const publicUrl = urlData?.publicUrl;

    console.log('[Storage] Generated public URL:', publicUrl);

    if (!publicUrl) {
      console.error('[Storage] Public URL is null or undefined');
      throw new Error('Failed to generate public URL for uploaded image');
    }

    return {
      path: data?.path,
      url: publicUrl
    };
  },

  // Upload content image for a post
  async uploadContentImage(postId, file) {
    console.log('[Storage] Starting content image upload:', { postId, fileName: file?.name, fileSize: file?.size });
    
    const fileExt = file?.name?.split('.')?.pop();
    const fileName = `${Date.now()}-${Math.random()?.toString(36)?.substring(7)}.${fileExt}`;
    const filePath = `posts/${postId}/content/${fileName}`;

    console.log('[Storage] Upload path:', filePath);

    const { data, error } = await supabase?.storage?.from('blog')?.upload(filePath, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (error) {
      console.error('[Storage] Upload error:', error);
      throw error;
    }

    console.log('[Storage] Upload successful:', data);

    // Get public URL
    const { data: urlData } = supabase?.storage?.from('blog')?.getPublicUrl(filePath);
    const publicUrl = urlData?.publicUrl;

    console.log('[Storage] Generated public URL:', publicUrl);

    if (!publicUrl) {
      console.error('[Storage] Public URL is null or undefined');
      throw new Error('Failed to generate public URL for uploaded image');
    }

    return {
      path: data?.path,
      url: publicUrl
    };
  },

  // Delete image from storage
  async deleteImage(filePath) {
    const { error } = await supabase?.storage?.from('blog')?.remove([filePath]);

    if (error) throw error;
  },

  // Get public URL for an image
  getPublicUrl(filePath) {
    const { data: { publicUrl } } = supabase?.storage?.from('blog')?.getPublicUrl(filePath);

    return publicUrl;
  }
};